import { Component, Input } from '@angular/core';

@Component({
    selector: 'core-layout-error-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss']
})
export class LayoutErrorNotFoundComponent {
}
